import { CardThemeBasicViewModel } from "../../../shared/components/card/cardThemeBasic/CardThemeBasicViewModel";
import { ThemeStructure } from "../../../shared/contentStructure/ThemeStructure";
import { IProgressStore } from "../../../shared/stores/ProgressStore";

export class ThemeListItemViewModel extends CardThemeBasicViewModel {
  constructor(public themeStructure: ThemeStructure, progressStore: IProgressStore) {
    super(themeStructure, progressStore);
  }
}
